import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CompanyConfig } from '../models/company-config.model';
import { RestResponse } from '../models/restResponse.mode';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CompanyConfigService {
  private readonly baseUrl = `${environment.base_url}/companies`;

  constructor(private http: HttpClient) {}

  get(): Observable<RestResponse<CompanyConfig>> {
    return this.http.get<RestResponse<CompanyConfig>>(`${this.baseUrl}`);
  }

  save(companyConfig: CompanyConfig): Observable<RestResponse<CompanyConfig>> {
    return this.http.post<RestResponse<CompanyConfig>>(`${this.baseUrl}`, companyConfig);
  }

  update(id: number, companyConfig: CompanyConfig): Observable<RestResponse<CompanyConfig>> {
    return this.http.put<RestResponse<CompanyConfig>>(`${this.baseUrl}/find/${id}`, companyConfig);
  }
}
